import http from "../http-common";

class UserService {
  getAll() {
    return http.get("/users");
  }

  /** Users from all tenants (requires users.view_all_tenants). Use only on Tenant Users page. */
  getAllTenantUsers() {
    return http.get("/admin/all-tenant-users");
  }

  get(id) {
    return http.get(`/users/${id}`);
  }

  create(data) {
    return http.post("/users", data);
  }

  update(id, data) {
    return http.put(`/users/${id}`, data);
  }

  delete(id) {
    return http.delete(`/users/${id}`);
  }

  // User-specific methods
  updateProfile(data) {
    return http.put("/users/profile", data);
  }

  changePassword(data) {
    return http.put("/users/change-password", data);
  }

  assignRoles(userId, roleIds) {
    return http.post(`/users/${userId}/roles`, { roles: roleIds });
  }

  removeRoles(userId, roleIds) {
    return http.delete(`/users/${userId}/roles`, { data: { roles: roleIds } });
  }

  assignPermissions(userId, permissionIds) {
    return http.post(`/users/${userId}/permissions`, { permissions: permissionIds });
  }

  removePermissions(userId, permissionIds) {
    return http.delete(`/users/${userId}/permissions`, { data: { permissions: permissionIds } });
  }

  sendWelcomeEmail(userId) {
    return http.post(`/users/${userId}/send-welcome-email`);
  }
}

export default new UserService();
